// extracted by mini-css-extract-plugin
export default {"subHeader":"aF7yS","address":"s7rbf"};